import React, { memo } from 'react';
import { Tabs, Tab } from '../../../../components/navigation/Tabs';

export interface TabularSwitcherTab {
  id: string;
  label: string;
  disabled?: boolean;
  icon?: React.ComponentType<any>;
  badge?: string | number;
}

export interface TabularSwitcherProps {
  tabs: TabularSwitcherTab[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
  className?: string;
  variant?: 'default' | 'compact' | 'pills';
  align?: 'left' | 'center' | 'right';
}

export const TabularSwitcher = memo(function TabularSwitcher({
  tabs,
  activeTab,
  onTabChange,
  className = '',
  variant = 'default',
  align = 'left'
}: TabularSwitcherProps) {
  // Convert TabularSwitcherTab to Tab format for the base Tabs component
  const convertedTabs: Tab[] = tabs.map(tab => ({
    id: tab.id,
    label: tab.label,
    disabled: tab.disabled,
    icon: tab.icon ? <tab.icon /> : undefined,
    badge: tab.badge
  }));
  
  return (
    <div className={`tabular-switcher tabular-switcher--${align} ${className}`}>
      <Tabs
        tabs={convertedTabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
        variant={variant === 'pills' ? 'default' : variant}
      />
    </div>
  );
});
